import { render, staticRenderFns } from "./dot.vue?vue&type=template&id=57552fb7&scoped=true"
import script from "./dot.vue?vue&type=script&lang=js"
export * from "./dot.vue?vue&type=script&lang=js"
import style0 from "./dot.vue?vue&type=style&index=0&id=57552fb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57552fb7",
  null
  
)

export default component.exports